import type {
	DerivedDeviceState,
	DerivedDeviceStateCreatedResponse,
	DerivedDeviceStateParams,
	DerivedDeviceStateStatusResponse,
} from '../derivedDeviceStateApi'

/** The demo backend has no derived-device-state store, so the feature reads as "none configured". */
const unsupported = (): never => {
	throw new Error('Derived device states are not available in the demo')
}

export const derivedDeviceStateApi = {
	getDerivedDeviceStates: async (_tenantId?: string, _impersonateAdmin?: boolean): Promise<DerivedDeviceState[]> => [],

	createDerivedDeviceState: async (
		_params: DerivedDeviceStateParams,
		_tenantId?: string,
	): Promise<DerivedDeviceStateCreatedResponse> => unsupported(),

	updateDerivedDeviceState: async (
		_id: number,
		_params: DerivedDeviceStateParams,
		_tenantId?: string,
	): Promise<DerivedDeviceStateStatusResponse> => unsupported(),

	deleteDerivedDeviceState: async (_id: number, _tenantId?: string): Promise<DerivedDeviceStateStatusResponse> =>
		unsupported(),
}
